/*
 * Copyright (c) 2026 Paxia AI Pty Ltd. All rights reserved.
 * This software is proprietary and confidential.
 * No part of this codebase may be copied, modified, published, distributed, sublicensed, or used without prior written permission from Paxia AI Pty Ltd.
 */

import { PrismLight as PrismSyntaxHighlighter } from 'react-syntax-highlighter';
import { oneDark as prismDarkStyle, oneLight as prismLightStyle } from 'react-syntax-highlighter/dist/esm/styles/prism';
import bash from 'react-syntax-highlighter/dist/esm/languages/prism/bash';
import css from 'react-syntax-highlighter/dist/esm/languages/prism/css';
import diff from 'react-syntax-highlighter/dist/esm/languages/prism/diff';
import javascript from 'react-syntax-highlighter/dist/esm/languages/prism/javascript';
import json from 'react-syntax-highlighter/dist/esm/languages/prism/json';
import jsx from 'react-syntax-highlighter/dist/esm/languages/prism/jsx';
import markdown from 'react-syntax-highlighter/dist/esm/languages/prism/markdown';
import markup from 'react-syntax-highlighter/dist/esm/languages/prism/markup';
import python from 'react-syntax-highlighter/dist/esm/languages/prism/python';
import sql from 'react-syntax-highlighter/dist/esm/languages/prism/sql';
import tsx from 'react-syntax-highlighter/dist/esm/languages/prism/tsx';
import typescript from 'react-syntax-highlighter/dist/esm/languages/prism/typescript';
import yaml from 'react-syntax-highlighter/dist/esm/languages/prism/yaml';

const REGISTERED_LANGUAGES = {
  bash,
  css,
  diff,
  javascript,
  json,
  jsx,
  markdown,
  markup,
  python,
  sql,
  tsx,
  typescript,
  yaml,
};

Object.entries(REGISTERED_LANGUAGES).forEach(([language, grammar]) => {
  PrismSyntaxHighlighter.registerLanguage(language, grammar);
});

const LANGUAGE_ALIASES = {
  cjs: 'javascript',
  console: 'bash',
  html: 'markup',
  js: 'javascript',
  md: 'markdown',
  mjs: 'javascript',
  plaintext: 'text',
  py: 'python',
  shell: 'bash',
  shellscript: 'bash',
  sh: 'bash',
  svg: 'markup',
  ts: 'typescript',
  xml: 'markup',
  yml: 'yaml',
  zsh: 'bash',
};

export const resolveSyntaxLanguage = (language) => {
  const normalized = String(language || '').trim().toLowerCase();
  if (!normalized) {
    return undefined;
  }

  const resolved = LANGUAGE_ALIASES[normalized] || normalized;
  if (!Object.prototype.hasOwnProperty.call(REGISTERED_LANGUAGES, resolved)) {
    return undefined;
  }

  return resolved;
};

export { PrismSyntaxHighlighter, prismDarkStyle, prismLightStyle };
